// Keep first: rewrites /invite-signup?token=... to the hash route before the router reads the URL.
import "@/routes/normalizeInviteUrl";
import app from "./app";
import store from "@/argon/store";
import router from "@/routes";
import i18n from "@/locales";
import argonV3 from "@/argon/argonV3";
import "@/assets/proxima-blue.scss";
import VueVideoPlayer from "@videojs-player/vue";
import "video.js/dist/video-js.css";
import VueGtag from 'vue-gtag-next';

app.use(store);
app.use(router);
app.use(i18n);
app.use(argonV3);
app.use(VueVideoPlayer);
app.use(VueGtag, {
    property: {
        id: 'G-J5VVKEBXMD',
    },
    config: {
        send_page_view: false
    }
}, router);

app.mount("#app");